import styled from '@emotion/styled';
import type { FC, PropsWithChildren } from 'react';
import { PopoverHint } from '../../BasicComponents/PopoverHint';

type Props = PropsWithChildren<{
  title?: string | React.ReactNode;
  hint?: string | React.ReactNode;
}>;

export const Checkpoint: FC<Props> = ({ title, hint, children }) => {
  return (
    <Container>
      {title != null && (
        <>
          <b>
            {title}:{hint != null && <PopoverHint>{hint}</PopoverHint>}
          </b>
          <br />
        </>
      )}
      {children}
    </Container>
  );
};

const Container = styled.div`
  border: solid 1px #dee2e6;
  border-radius: 0.25rem;
  padding: 10px;
  background-color: white;
`;
